import React from "react";
import LandingAndroidAppsSection from "./LandingAndroidAppsSection";
import "./landingAppFirst.css";

/** Sidebar page for the mobile app showcase. */
export default function MobileAppsPage() {
    return (
        <div className="pi-landing">
            <LandingAndroidAppsSection />
        </div>
    );
}
